/**
 * Application constants and configuration
 */

// Camera settings
export const CAMERA_CONFIG = {
    DEFAULT_FOV: 75,
    NEAR_PLANE: 0.1,
    FAR_PLANE: 1000,
    POSITION: { x: 0, y: 0, z: 0.1 }
};

// Sphere settings
export const SPHERE_CONFIG = {
    RADIUS: 500,
    WIDTH_SEGMENTS: 32, // Reduced from 60 for better performance
    HEIGHT_SEGMENTS: 32  // Reduced from 40 for better performance
};

// Zoom levels (FOV values from wide to narrow)
export const ZOOM_LEVELS = [120, 90, 75, 60, 45];
export const DEFAULT_ZOOM_LEVEL = 2; // Middle level (75°)

// Controls settings
export const CONTROLS_CONFIG = {
    DAMPING_FACTOR: 0.05,
    ROTATE_SPEED: 0.25,
    ZOOM_SPEED: 1.0,
    MIN_DISTANCE: 0.1,
    MAX_DISTANCE: 500,
    MIN_POLAR_ANGLE: 0,
    MAX_POLAR_ANGLE: Math.PI
};

// Transition settings
export const TRANSITION_CONFIG = {
    DEFAULT_DURATION: 500, // milliseconds
    MIN_DURATION: 100,
    MAX_DURATION: 2000
};

// Tripod mask settings
export const TRIPOD_MASK_CONFIG = {
    DEFAULT_SIZE: 1.0,
    BASE_GEOMETRY_SIZE: 200,
    POSITION_Y: -480, // Slightly raised to avoid texture stutter
    ROTATION_X: -Math.PI / 2
};

// Hotspot settings
export const HOTSPOT_CONFIG = {
    SIZES: {
        small: 0.5,
        medium: 1.0,
        large: 2.0,
        original: 1.0
    },
    BASE_SIZE: 100,
    OFFSET_FROM_SURFACE: -20,
    DEFAULT_SIZE: 'medium'
};

// Navigation marker settings
export const NAVIGATION_MARKER_CONFIG = {
    SIZE: 80,
    OPACITY: 0.9,
    POSITION_SCALE: 0.95,
    ANIMATION_AMPLITUDE: 5,
    ANIMATION_SPEED: 0.02
};

// FPS counter settings
export const FPS_CONFIG = {
    UPDATE_INTERVAL: 1000 // milliseconds
};

// Status message settings
export const STATUS_CONFIG = {
    AUTO_HIDE_DELAY: 3000 // milliseconds
};

// Scene settings
export const SCENE_CONFIG = {
    BACKGROUND_COLOR: 0x000000 // Black
};

// Crosshair settings
export const CROSSHAIR_CONFIG = {
    SIZE: 24, // Size in pixels
    COLOR: '#ffffff', // White color
    OUTLINE_COLOR: '#000000', // Black outline
    THICKNESS: 3, // Line thickness in pixels
    OUTLINE_THICKNESS: 1, // Outline thickness in pixels
    OPACITY: 0.9 // CSS opacity
};

// API settings
export const API_CONFIG = {
    BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api',
    ENDPOINTS: {
        AUTH_ME: '/api/v2/auth/me',
        SAVE: '/api/v2/galleries-360/upload',
        LOAD: '/api/v2/galleries-360/load',
        UPLOAD_IMAGE: '/api/v2/galleries-360/upload-image'
    }
};

